import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import LatestResources from './components/LatestResources';
import HotResources from './components/HotResources';
import Features from './components/Features';
import FAQ from './components/FAQ';

export default function Home() {
  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '老六资源库',
    url: 'https://laoliu-resource.com',
    description: '老六资源库是专为资源爱好者打造的一站式资源聚合平台，涵盖学习资料、工具软件、影音素材等海量优质内容。',
    sameAs: ['https://weibo.com/laoliu', 'https://weixin.qq.com/laoliu'],
  };

  const webSiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '老六资源库',
    url: 'https://laoliu-resource.com',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://laoliu-resource.com/?search={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const webPageSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '老六资源库 - 海量资源一站式获取平台',
    description: '老六资源库是专为资源爱好者打造的一站式资源聚合平台，涵盖学习资料、工具软件、影音素材等海量优质内容。免费分享，持续更新。',
    url: 'https://laoliu-resource.com',
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(orgSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(webSiteSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(webPageSchema)}</script>
      <Navbar />
      <main>
        <HeroSection />
        <CategoryGrid />
        <LatestResources />
        <HotResources />
        <Features />
        <FAQ />
      </main>
      <Footer />
      <ScrollToTop />
    </>
  );
}